import { API_BASE_URL, CONTACT_EMAIL } from '../config/app-config';

const WEB3FORMS_URL = 'https://api.web3forms.com/submit';

/**
 * Sends the contact form. Order:
 * 1) Web3Forms (REACT_APP_WEB3FORMS_ACCESS_KEY) — register at web3forms.com with recipient {CONTACT_EMAIL}
 * 2) POST {API_BASE_URL}/contact — if your backend implements it
 */
export async function submitContactForm({ name, email, message }) {
  const web3Key = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;
  if (web3Key) {
    const res = await fetch(WEB3FORMS_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        access_key: web3Key,
        subject: `FilmųDB — žinutė nuo ${name}`,
        name,
        email,
        message,
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (data.success) {
      return { ok: true };
    }
    return {
      ok: false,
      error: data.message || 'web3forms_error',
    };
  }

  if (API_BASE_URL) {
    try {
      const res = await fetch(`${API_BASE_URL.replace(/\/$/, '')}/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ name, email, message }),
      });
      if (res.ok) {
        const data = await res.json().catch(() => ({}));
        if (data.success !== false) {
          return { ok: true };
        }
      }
    } catch {
      // fall through
    }
  }

  return { ok: false, error: 'not_configured', contactEmail: CONTACT_EMAIL };
}
